// extracted by mini-css-extract-plugin
export default {"title":"Fba-z","warning":"Gba-z","sizeOptionsLegendText":"Hba-z"};